var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6406 8.86269C16.6406 13.0421 13.5427 16.4973 9.51829 17.058C9.142 17.1101 8.75701 17.1374 8.36622 17.1374C7.91513 17.1374 7.47216 17.1015 7.04078 17.0319C3.10099 16.3975 0.0917969 12.9812 0.0917969 8.86269C0.0917969 4.2925 3.79676 0.587402 8.3668 0.587402C12.9368 0.587402 16.6418 4.2925 16.6418 8.86269H16.6406Z",
    fill: "#1C1C1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4476 4.23682L7.26389 9.33929L3.42383 13.488H4.28832L7.65062 9.85592L10.367 13.488H13.3084L9.27755 8.09846L12.8521 4.23682H11.9876L8.8914 7.58184L6.38954 4.23682H3.44818H3.4476ZM4.71853 4.87347H6.06949L12.0363 12.8513H10.6853L4.71853 4.87347Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogo);
export default __webpack_public_path__ + "static/media/twitter_logo.580cfae9e175ddcd9d603300b85529dc.svg";
export { ForwardRef as ReactComponent };